<template>
    <div>
        <div class="header-btn">
            <el-button size="small" type="warning" @click="openCreate" icon="el-icon-plus"></el-button>
        </div>

        <el-table
                fit
                stripe
                class="data-table"
                :data="data">
            <el-table-column
                    v-for="item in [
                        {prop:'file.name',label:'Document Name'},
                        {prop:'createDate',label:'Created Time',fmt:selfTimeFormat},
                    ]"
                    :formatter="item.fmt"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    align="center"
                    label="Action">
                <template slot-scope="s">
                    <el-button type="danger" @click="deleteData(s.row.id)" icon="el-icon-delete"
                               size="mini"></el-button>
                </template>
            </el-table-column>

        </el-table>
        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :close-on-click-modal="false"
                :visible.sync="dialogVisible"
                width="30%">
                <el-form ref="form" :model="form" :rules="rules">
                    <el-form-item style="text-align: center">
                        <file-uploader :uploaded-files.sync="form.files"></file-uploader>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="saveData" size="medium">Save</el-button>
                    <el-button @click="dialogVisible = false" size="medium">Cancel</el-button>
                </span>
        </el-dialog>
    </div>
</template>

<script>

    import {createDoc, docsList, updateDoc, deleteDoc} from '@/api/BulletinAPI'
    import FileUploader from '@/components/FileUploader'

    export default {
        name: 'BulletinFile',
        components: {FileUploader},
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                form: {},
                loading: false,
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                }
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, docsList)
            },
            openCreate() {
                this.form = {files: []}
                this.dialogVisible = true
            },
            saveData() {
                const action = this.form.id ? updateDoc : createDoc
                this.$refs['form'].validate((valid) => {
                    if (valid) {
                        const form = {
                            fid: this.form.files[0].id
                        }
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            },
            deleteData(id) {
                this.$deleteRequest(this, deleteDoc, id)
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
